// Copyright (C) 2021 Bystronic Laser AG

export const TOTAL_ROWS = 8;
export const TOTAL_COLUMNS = 12;

export interface LayoutSlot {
  row: number;
  column: number;
  width: number;
  height: number;
}
